var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#001E3C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.5 17.01a.47.47 0 0 1-.35-.15c-.2-.2-.2-.51 0-.71l10-9.99c.2-.2.51-.2.71 0s.2.51 0 .71l-10 9.99c-.1.1-.23.15-.35.15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 17.01a.47.47 0 0 1-.35-.15l-9.99-10c-.2-.2-.2-.51 0-.71s.51-.2.71 0l9.99 10c.2.2.2.51 0 .71-.1.1-.23.15-.35.15z"
}))));
export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZmJjYTNmNTU2MGJlNDdiZWI5OWRhMmYwNjRjNzIyOGQuc3ZnIjs=";